export function getTouchDirection(angle, range) {
  var direction = false,
      gap = Math.abs(90 - Math.abs(angle));
      
  if (gap >= 90 - range) {
    direction = 'horizontal';
  } else if (gap <= range) {
    direction = 'vertical';
  }

  return direction;
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/getTouchDirection.js
// module id = 853
// module chunks = 2